import { useQuery } from '@tanstack/react-query';

import { aiReportTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getPageReportPages: aiReportTypes.GetPages = (params) => {
  return axios.get('/page-reports/pages', { params });
};

type QueryFnType = typeof getPageReportPages;

type UseGetPageReportPagesOptions = {
  geo?: aiReportTypes.Geo | null;
  source?: aiReportTypes.Source | null;
  config?: QueryConfig<QueryFnType>;
};

export const useGetPageReportPages = ({
  geo,
  source,
  config = {},
}: UseGetPageReportPagesOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['page-report-pages', geo, source],
    enabled: Boolean(geo && source),
    queryFn: () =>
      getPageReportPages({ geo: geo as aiReportTypes.Geo, source: source as aiReportTypes.Source }),
  });
};
